export enum FloorplanSelectedItemType {
  AirPath = "AirPath",
  AlarmDevice = "AlarmDevice",
  CableRoute = "CableRoute",
  Default = "Default",
  GasWarningCenter = "GasWarningCenter",
  Image = "Image",
  MeasurementLine = "MeasurementLine",
  None = "None",
  Pipeline = "Pipeline",
  Placeholder = "Placeholder",
  PlasticSign = "PlasticSign",
  ProtectiveTube = "ProtectiveTube",
  ReferenceMeasure = "ReferenceMeasure",
  SignalElement = "SignalElement",
  Transmitter = "Transmitter",
  FlameDetector = "FlameDetector",
  Wire = "Wire",
  Zone = "Zone",
  PatientMonitor = "PatientMonitor",
  CentralStation = "CentralStation",
  Telemetry = "Telemetry",
  Kvm = "Kvm",
  Display = "Display",
  Utility = "Utility",
  FreeText = "FreeText",
}
